"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgEyeOff(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)("path", {
      fill: "currentColor",
      d: "M3.74 3.03c.347-.093.716.006.97.26l16 16a.997.997 0 010 1.42.997.997 0 01-1.42 0l-5.63-5.63a3.501 3.501 0 01-4.74-4.74L3.29 4.71a1.003 1.003 0 01.45-1.68zM5 7.87l1.46 1.41C5.6 10.086 4.846 11 4.22 12c.88 1.41 3.7 5.1 8 5a7.756 7.756 0 001.7-.25l1.58 1.58a9.494 9.494 0 01-3.23.67h-.25c-5.89 0-9.26-5.41-9.89-6.5a.998.998 0 010-1A15.85 15.85 0 015 7.87zM11.73 5c5.97-.18 9.5 5.39 10.14 6.5.191.302.206.683.04 1A15.885 15.885 0 0119 16.13l-1.51-1.41A13.71 13.71 0 0019.78 12c-.89-1.41-3.71-5.11-8-5a7.756 7.756 0 00-1.7.25L8.5 5.67A9.494 9.494 0 0111.73 5zm-1.23 6.93V12a1.5 1.5 0 001.5 1.5l.06-.01-1.56-1.56z"
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=EyeOff.js.map